export const formatCurrency = (amt: number): string => {
  const formatter = new Intl.NumberFormat('en-MY', {
    style: 'currency',
    currency: 'MYR',
  });

  return formatter.format(amt);
};
